import m from 'mithril';
import { HotelResult, HotelResultSet, InitialConfigurationData } from '../../Models';
import { SubFsm } from 'little-fsm';
import { AppComponents } from '../../app_common_setup';
import HotelSearchPage from '../../components/desktop/hotelsearch/HotelSearchPage';
import { HotelSubMainifest } from '../../states/app_desktop_root';
import HotelSearchCriteria from '../../states/HotelSearchCriteria';

let lastHotelResultSet:HotelResultSet|undefined = undefined; 
let hasMoreHotels:boolean = false;
let isLoadingMore:boolean = false;

export function buildHotelsPresenter(subFsm:SubFsm<HotelSubMainifest>, appComponents:AppComponents, initialConfigData:InitialConfigurationData): {render:() => m.Vnode<any, any>} {
    let dataSource = appComponents.dataSource;
    let messageProvider = appComponents.messageProvider;

    function loadMoreHotels(searchCriteria: HotelSearchCriteria) {
        if (isLoadingMore || !hasMoreHotels) {
            return;
        }

        isLoadingMore = true;
        m.redraw();

        console.log("is loading more ..." + isLoadingMore)
        
        const currentCount = lastHotelResultSet?.hotelResults.length ?? 0;
        const requestCriteria = searchCriteria.withOffset(currentCount + 1);        

        console.log("Loading more hotels. currentCount=" + currentCount + ", offset=" + requestCriteria.getOffset());

        dataSource.searchHotels(requestCriteria)
            .then(resultSet => {
                if (resultSet.hotelResults.length === 0) {
                    hasMoreHotels = false;
                    return;
                }

                if (lastHotelResultSet) {
                    lastHotelResultSet = {
                        ...resultSet,
                        hotelResults: [
                            ...lastHotelResultSet.hotelResults,
                            ...resultSet.hotelResults
                        ]
                    };
                } else {
                    lastHotelResultSet = resultSet;
                }

                hasMoreHotels = lastHotelResultSet.hotelResults.length < lastHotelResultSet.pagination.totalResultRows;
            })
            .catch(error => {
                console.error(
                    "Failed to load more hotels",
                    error
                );
            })
            .finally(() => {
                isLoadingMore = false;
                m.redraw();
            });
    }

    subFsm.setEnterEffect('search_progressing', ctx => {
        let searchCriteria = ctx.searchCriteria;
        dataSource.searchHotels(searchCriteria).then(resultSet => {
            lastHotelResultSet = resultSet;
            hasMoreHotels = resultSet.hotelResults.length < resultSet.pagination.totalResultRows;
            subFsm.processEvent('search_succeeded', {
                searchCriteria: searchCriteria,
                hotelResultSet: resultSet
            })
        });
    })

    subFsm.setEnterEffect('selecting_hotel', ctx => {
        if(ctx.hotelResult != null){
            let hotelDetailsUrlTemplate = appComponents.rootElement.getAttribute("data-hotel-detail-url-template");
            if(hotelDetailsUrlTemplate != null) {
                let hotelDetailsUrl = hotelDetailsUrlTemplate.replace(":hotelId", ctx.hotelResult.hotel.id + "") +
                                    "?checkInDate="+ ctx.hotelSearchFormState.checkInDate +"&checkOutDate="+ ctx.hotelSearchFormState.checkOutDate
                                    +"&numberOfRooms="+ ctx.hotelSearchFormState.numberOfRooms +"&guestType="+ ctx.hotelSearchFormState.guestType;
                console.log("url : " + hotelDetailsUrl)
                window.open(hotelDetailsUrl);
            }
            subFsm.processEvent('hotel_selected', {})
        }
    })

    return {
        render() {
            let context = subFsm.getCurrentContext();

            return m(HotelSearchPage, {
                locations: initialConfigData.locations,
                messageProvider : messageProvider,
                searchCriteria: context.searchCriteria,
                hotelResults: lastHotelResultSet?.hotelResults,
                filterFieldGroup: lastHotelResultSet?.filterFieldGroup,
                sortingFieldGroup: lastHotelResultSet?.sortingFieldGroup,   
                isLoadingMore: isLoadingMore,  
                onSearch : function(searchCriteria){
                    if(lastHotelResultSet != undefined) {
                        lastHotelResultSet.hotelResults = [];
                    }
                    subFsm.processEvent('search_submitted', {
                        searchCriteria: searchCriteria
                    }) 
                },

                onHotelResultSelected: (hotelResult:HotelResult) => {
                    subFsm.processEvent('hotel_requested', {
                        hotelResult: hotelResult
                    })
                },
                onLoadMore: function () {
                    loadMoreHotels(context.searchCriteria);
                }
            })
        }
    }
}